import React, { FC } from 'react';
import { VerticalTabButton } from '@epam/promo';
import { useLocation } from 'react-router-dom';
import { useNavigationHandler } from 'hooks';

interface IMenuItem {
  caption: string;
  pathname: string;
}

interface IVerticalNavigationTabsProps {
  menuItems: IMenuItem[];
}

const VerticalNavigationTabs: FC<IVerticalNavigationTabsProps> = ({
  menuItems,
}) => {
  const { pathname } = useLocation();
  const handleNavigation = useNavigationHandler();

  const tabs = menuItems.map(({ caption, pathname: itemPathname }) => (
    <VerticalTabButton
      key={caption}
      caption={caption}
      isActive={pathname === itemPathname}
      onClick={() => handleNavigation(itemPathname)}
    />
  ));

  return <>{tabs}</>;
};

const MemoizedVerticalNavigationTabs = React.memo(VerticalNavigationTabs);

export { MemoizedVerticalNavigationTabs as VerticalNavigationTabs };
